import AbstractScene from './AbstractScene.js';
import ButtonImageSliced from '../prefabs/ButtonImageSliced.js';
import { Colors } from '../consts/Colors.js';


export default class ActiviteB1 extends AbstractScene {
    constructor() {
        super({
            key: "ActiviteB1"
        })
    }
    init(data) {
        this._init(data);
    }

   preload() {
        this._preload();
        this.videoKey = 'videoB1';
        this.postTarget = () => {
            if (this.game.data.level === 4) {
                this.game.data.level = 5
            }
            this.scene.start('Menu')
        };
        this.allControls = []
    }

    update() {
        if (this.isPlaying && !this.isDraging) {
            this.currentTiming = this.video.getCurrentTime()
            this.totalDuration = this.video.getDuration()
            this.slider.value = this.currentTiming / this.totalDuration
            const progress = this.video.getProgress();
            this.barFill.width = progress * 900;
        } else if (this.isDraging) {
            const progress = this.video.getProgress();
            const duration = this.video.getDuration();
            const current = progress * duration;
            this.currentTimeText.setText(this.formatTime(current));
            this.barFill.width = this.slider.value * 900;
        }
        if (this.isPlaying) {
            const duration = this.video.getDuration();
            const progress = this.video.getProgress();
            const current = progress * duration;
            this.currentTimeText.setText(this.formatTime(current));
            this.durationText.setText(this.formatTime(duration));
        }
    }


    create() {
        this.isDraging = false
        this.isPlaying = false
        this.isPaused = true;

        const blocker = this.add.image(this.width / 2, this.height / 2-40, this.videoKey + 'Blocker').setDepth(0.5).setScale(0.9);

        // 📹 1. Ajoute la vidéo
        this.video = this.add.video(0, 0, this.videoKey).setOrigin(0.5).setDepth(1).setScale(0.9)
        this.video.setPaused(true)
        this.video.setVolume(1)

        // 2. On centre la vidéo au milieu du canvas
        this.video.setPosition(this.width / 2, this.height / 2 - 40);

        this.startBtn = new ButtonImageSliced(this, 255, this.height - 50, 150, 30, "bouton", "Play")
        this.startBtn.setDepth(20)
        this.allControls.push(this.startBtn);

        this.startBtn.setClickFunction(() => {
            if (hasEnded) return;
            // Si la vidéo est en pause, la reprendre
            if (this.isPaused) {
                this.video.resume();
                this.video.setMute(false);
                this.isPaused = false;
                this.isPlaying = true
                this.startBtn.setTextContent("Pause");
            } else {
                // Sinon, mettre la vidéo en pause
                this.startBtn.setTextContent("Play");
                this.video.pause();
                this.isPlaying = false
                this.isPaused = true;
            }

        })
        // ⏱️ Texte durée
        this.currentTimeText = this.add
            .text(1635, this.height - 45, '0:00', {
                fontSize: "20px",
                color: Colors.Text.MainBlue,
                fontFamily: 'CenturyGothic',
            })
            .setOrigin(0.5).setDepth(20)
        this.allControls.push(this.currentTimeText);

        this.barretime = this.add
            .text(1665, this.height - 45, '/', {
                fontSize: "20px",
                color: Colors.Text.MainBlue,
                fontFamily: 'CenturyGothic',
            })
            .setOrigin(0.5).setDepth(20)
        this.allControls.push(this.barretime);


        this.durationText = this.add
            .text(1695, this.height - 45, "0:00", {
                fontSize: "20px",
                color: Colors.Text.MainBlue,
                fontFamily: 'CenturyGothic',
            })
            .setOrigin(0.5).setDepth(20)
        this.allControls.push(this.durationText);


        this.sliderLine = this.add.rexRoundRectangle(this.width / 2, this.height - 40, 900, 6, 3, Colors.Elmt.MainBlue).setAlpha(0.5).setDepth(20)
        this.allControls.push(this.sliderLine);
        this.barFill = this.add.rexRoundRectangle(this.width / 2 - 450, this.height - 40, 0, 6, 3, Colors.Elmt.MainBlue).setOrigin(0, 0.5).setDepth(20)
        this.allControls.push(this.barFill);
        this.sliderLine.setSize(900, this.sliderLine.height)
        this.sliderLine.setInteractive({ useHandCursor: true });
        this.sliderLine.on('pointerdown', (event) => {
            let a = event.x
            let b = this.sliderLine.x
            let c = a - b
            let value = (c + 450) / 900
            this.barFill.width = value * 900
            this.slider.value = value
            this.video.seekTo(value);
        })
        this.sliderButton = this.add.circle(this.width / 2 - 450, this.height - 40, 15, Colors.Elmt.MainBlue).setInteractive({ useHandCursor: true }).setAlpha(1).setDepth(20)
        this.allControls.push(this.sliderButton);
        this.sliderButton.setStrokeStyle(4, Colors.Elmt.White)
        this.sliderButton.on('pointerdown', () => {
            this.isDraging = true
            this.isPlaying = false
            this.video.setPaused(true)
        })
        this.sliderButton.on('pointerup', () => {
            this.isDraging = false
            if (this.isPaused) {
                this.isPlaying = false
                this.video.setPaused(true)
            } else {
                this.isPlaying = true
                this.video.setPaused(false)
            }
        })

        this.input.on('pointerup', () => {
            if (this.isDraging) {
                this.isDraging = false
                this.isPlaying = true
                this.video.setPaused(false)
            }
        })

        this.slider = this.plugins.get('rexSlider').add(this.sliderButton, {
            endPoints: [
                { x: this.sliderLine.x - 450, y: this.sliderLine.y },
                { x: this.sliderLine.x + 450, y: this.sliderLine.y }
            ],
            value: 0,
            enable: true,
            valuechangeCallback: (value) => {
                if (this.isDraging) {
                    this.video.seekTo(value);
                }
            }
        });

        // 📥 Sur fin de la vidéo
        let hasEnded = false;

        this.video.on('complete', () => {
            hasEnded = true;
            this.postTarget(this);
        });
    }

    formatTime(seconds) {
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${mins}:${secs < 10 ? '0' : ''}${secs}`;
    }

}